export default {
  "pl": {
    "employee": {
      "actions": {
        "cancel": "Cofnij",
        "changeProfilePicture": "Zmień zdjęcie profilowe",
        "new": "Nowy członek zespołu",
        "profilePictureFormat": "Minimalne wymiary to: 300 ⨯ 300 px",
        "save": "Zapisz",
        "searchEmployee": "Wyszukaj członka zespołu",
        "sendinvitation": "Utwórz i wyślij zaproszenie",
        "submit": "Zapisz",
        "undoChanges": "Cofnij"
      },
      "attributes": {
        "email_address": "E-mail",
        "email_notifications_interval": {
          "daily": "Raz dziennie (ok. południa)",
          "hourly": "Co godzinę",
          "twice_daily": "Dwa razy dziennie (rano i w południe)",
          "weekly": "Raz w tygodniu (w poniedziałek w południe)"
        },
        "first_name": "Imię",
        "language": "Język",
        "last_name": "Nazwisko",
        "phone_landline": "Numer stacjonarny",
        "phone_mobile": "Numer telefonu komórkowego",
        "profession": "Stanowisko",
        "role": "Uprawnienia dostępu",
        "status": "Status",
        "title": "Tytuł"
      },
      "labels": {
        "confirmPasswordReset": "Wysłaliśmy wiadomość e-mail z odnośnikiem umożliwiającym zresetowanie hasła. Sprawdź skrzynkę odbiorczą. W razie problemów skontaktuj się z nami.",
        "generalNotifications": "Powiadom mnie o:",
        "information": "Informacje profilowe",
        "informationNotificationsEmail": "Otrzymuj wiadomości e-mail z podsumowaniem tylko tych powiadomień, które nie zostały jeszcze wyświetlone na platformie.",
        "informationNotificationsPlatform": "Otrzymuj wszystkie powiadomienia w panelu w prawym górnym rogu ekranu:",
        "informationNotificationsTitle": "Zdecyduj o rodzaju i sposobie otrzymywania powiadomień",
        "maintainerAccess": "Wymaga dostępu do każdego z projektów.",
        "onPlatform": "Na platformie",
        "ownerAccess": "Ma dostęp do wszystkich projektów i treści na platformie klienta: {client_name}.",
        "password": "Hasło",
        "permissions": "Uprawnienia dostępu dla:",
        "permissionsOwnerOnly": "Jesteś opiekunem projektu, więc nie możesz tego zrobić. Poproś członka zespołu pełniącego rolę właściciela, aby zrobił to dla ciebie.",
        "projectMaintains": "{first_name} ma dostęp do następujących projektów:",
        "projectMaintainsAdd": "Aby udzielić dostępu, wybierz projekt i dodaj użytkownika {first_name} w roli opiekuna projektu w sekcji Informacje.",
        "projectMaintainsNone": "nie ma dostępu do żadnych projektów.",
        "projectNotifications": "Dla projektu",
        "viaEmail": "E-mailem"
      },
      "roles": {
        "maintainer": "Opiekun",
        "owner": "Właściciel"
      },
      "toasts": {
        "create": "Utworzono konto członka zespołu",
        "update": "Zaktualizowano dane członka zespołu"
      },
      "validation": {
        "emailTaken": "Ten adres e-mail jest już w użyciu",
        "mustBeEmailAddress": "Należy podać poprawny adres e-mail",
        "needFirstName": "Należy podać imię",
        "needLastName": "Należy podać nazwisko",
        "requireEmailAddress": "Należy podać adres e-mail"
      }
    }
  }
}
